.Paginate {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px 0 50px;
}
